module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "DWTcontainer"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "300px",
      "height": "350px",
      "margin": "0 auto"
    },
    attrs: {
      "id": "dwtcontrolContainer"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c062e32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/zhiFa/components/dwt.vue
// module id = mhyh
// module chunks = 4